module.exports = __webpack_public_path__ + "static/portal-da-oficina-logo-f7af52d557d0959be22258ff6eaf2957.svg";